module.exports = __webpack_public_path__ + "static/img/spread2-1.baef791.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/life/spread2-1.jpg
// module id = HbtN
// module chunks = 1